import '../../styles/components/tabs.scss'

class Tabs extends HTMLElement {
  constructor() {
    super();

    this.rememberTabs = this.hasAttribute('remember-tabs');
    this.tabButtons = Array.from(this.querySelectorAll('tab-button'));
    const tabEvent = this.hasAttribute('on-hover') ? 'mouseenter' : 'click';
    const externalId = this.dataset.externalId;
    this.externalItems = document.querySelectorAll(`[data-tab-external-id='${externalId}'] [data-tab-id]`);

    /**
     * We filter the tabButtons to only get the buttons that are not in another tabs-container.
     * This allows for nested tabs-container.
    */
    this.tabButtons = this.tabButtons.filter(tabButton => tabButton.closest('tabs-container') === this);

    this.tabButtons.forEach(button => {
      button.addEventListener(tabEvent, this.selecTab.bind(this));
    })

    if (this.rememberTabs) {
      const tabId = window.location.hash.slice(1);
      if (tabId) {
        this.openTab(tabId);
      }
    }
  }

  openTab(newTabId) {
    const openedTab = Array.from(this.querySelectorAll('tab-item[opened]'))
      .filter(tab => tab.closest('tabs-container') === this)[0];
    const openedTabId = openedTab.getAttribute('tab-id');
    const openedTabButton = this.querySelector(`tab-button[tab-id='${openedTabId}']`)

    const newTabButton = this.querySelector(`tab-button[tab-id='${newTabId}']`)
    const newTab = this.querySelector(`tab-item[tab-id='${newTabId}']`);

    this.externalItems.forEach(item => {
      item.classList.add('hide');

      if (item.dataset.tabId == newTabId) {
        item.classList.remove('hide');
      }
    });

    if (this.rememberTabs) {
      window.location.hash = `${newTabId}`;
    }

    if (!newTabButton.hasAttribute('opened')) {
      openedTabButton.removeAttribute('opened');
      newTabButton.setAttribute('opened', '');
    }

    if (!newTab.hasAttribute('opened')) {
      openedTab.removeAttribute('opened');
      newTab.setAttribute('opened', '');

      /**
       * Refreshes any swiper instances inside the new opened tab
       * to prevent display issues with swiper.
       */
      const swiperInTab = Array.from(newTab.querySelectorAll('swiper-container'));
      swiperInTab.forEach(swiper => {
        if (swiper && swiper.swiper) {
          swiper.swiper.update();
        }

        if (swiper && swiper.config.onOverflow) {
          swiper.onOverflow();
        }
      })
    }
  }

  selecTab(event) {
    const newTabButton = event.currentTarget;
    const newTabId = newTabButton.getAttribute('tab-id');

    this.openTab(newTabId);
  }
}

try {
  customElements.define('tabs-container', Tabs);
}
catch(e) {}
